/* Read more about error boundaries at: https://reactjs.org/docs/error-boundaries.html */
import { Component, ErrorInfo } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { Box } from '@mui/material';
import { ErrorBoundaryState } from './types';
import { getFirestoreInstance } from '../../../../services/firebase';

class ErrorBoundary extends Component<any, ErrorBoundaryState> {
    constructor(props: any) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error: Error) {
        // Update state so the next render will show the fallback UI.
        console.log(error);
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error,
            errorInfo,
        });

        if (window.location.href.match(/localhost/)) {
            return;
        }
        addDoc(collection(getFirestoreInstance(), 'logs'), {
            type: 'error',
            metadata: {
                error: JSON.stringify(error),
                errorInfo: JSON.stringify(errorInfo),
            },
            created_at: serverTimestamp(),
        });
    }

    render() {
        const { error, errorInfo } = this.state;
        const { children } = this.props;

        if (errorInfo) {
            // Error path
            return (
                <Box>
                    <h2>Something went wrong.</h2>
                    <Box component="details" sx={{ whiteSpace: 'pre-wrap' }}>
                        {error && error.toString()}
                        <br />
                        <br />
                        {errorInfo.componentStack}
                    </Box>
                </Box>
            );
        }
        // Normally, just render children
        return children;
    }
}

export default ErrorBoundary;
